<template>
	<SimpleModal @close="$emit('close')">
		<div class="container">
			<UserGroupIcon class="user-icon" />
			<div v-t="'apierrors_VIDEOSESSION_FULL'" />
			<button
				class="action-button block"
				@click="$emit('close')"
				:aria-label="$t('meetings_actionsheet_button_continue_observing')"
				v-t="'meetings_actionsheet_button_continue_observing'"
			/>
		</div>
	</SimpleModal>
</template>

<script>
import { SimpleModal } from '../common'
import { UserGroupIcon, CloseIcon } from '../../icons'

export default {
	name: 'MeetingLimitPopup',
	components: {
		SimpleModal,
		UserGroupIcon,
		CloseIcon,
	},
	emits: ['close']
}
</script>

<style lang="scss" scoped>
.container {
	padding: 16px 26px 24px 16px;
	max-width: 375px;
}

.action-button {
	font-size: 14px;
	padding: 8px 16px;
	border-radius: 20px;
	color: #4f5053;
	background: #eee;
	width: 275px;
	&.block {
		display: block;
		width: 100%;
		text-align: center;
	}
}

.user-icon {
	margin-bottom: 16px;
}

button {
	margin-top: 18px;
}
</style>
